<article class="chart-card first-chart-card">
    <header class="card-header">
        <div class="card-title-section">
            <h3 class="card-title">{{ selectedRequest?.title }}</h3>
            <p class="card-subtitle">{{ selectedRequest?.subtitle }}</p>
        </div>

        <button *ngIf="!hideMenu" mat-icon-button [matMenuTriggerFor]="firstChartMenu"
            #firstChartMenuTrigger="matMenuTrigger" class="card-action-btn" type="button"
            aria-label="Configure first chart data source">
            <mat-icon>tune</mat-icon>
        </button>

        <mat-menu #firstChartMenu="matMenu">
            <button mat-menu-item *ngFor="let option of chartOptionMenu"
                (click)="selectRequest(option);this.chartSelected.emit(option.requestId)"
                [class.font-semibold]="selectedRequest?.requestId === option.requestId">
                <mat-icon class="mr-2">{{ option.icon }}</mat-icon>
                <span>{{ option.label }}</span>
            </button>
        </mat-menu>
    </header>
    <disco-tab-provider *ngIf="selectedRequest" [config]="{appId: selectedRequest.appId, tabId: selectedRequest.tabId}"
        (context)="setTabContext($event)" [emitOnChanges]="true">
        <ng-template let-tabContext>
            <disco-report *ngIf="tabContext" [queryService]="selectedRequest.queryService"
                [requestId]="selectedRequest.requestId" (context)="setReportContext($event)">
                <ng-template let-reportContext>
                    <div class="card-body">
                        <div class="chart-legend" *ngIf="isDonutChart">
                            <ng-container *ngFor="let s of series">
                                <div class="legend-item" *ngFor="let item of s.data"
                                    [hidden]="s.type !== 'donut' || item.value === 0">
                                    <div class="legend-indicator">
                                        <span class="legend-dot" [style.background-color]="item.color"></span>
                                        <span class="legend-label">{{ item.category }}</span>
                                    </div>
                                    <span class="legend-value" *ngIf="item.category !== 'No Data'">{{ item.value |
                                        number : "1.0-1" }}</span>
                                </div>
                            </ng-container>
                        </div>
                        <div class="chart-container" [class.donut-chart]="isDonutChart" [style.width.%]="100"
                            [style.overflow]="scrollable ? 'auto' : 'visible'">
                            <div *ngIf="isChartLoading" class="loading-state">
                                <mat-spinner [diameter]="50"></mat-spinner>
                                <p>Loading chart data...</p>
                            </div>
                            <div *ngIf="!isChartLoading && (!series || series.length === 0)" class="empty-state">
                                <mat-icon>insert_chart_outlined</mat-icon>
                                <p>No data available for the selected period</p>
                            </div>
                            <kendo-chart [style.min-width.px]="scrollable ? 1200 : null" [style.width.%]="100"
                                *ngIf="!isChartLoading && series && series.length > 0" [transitions]="false"
                                [transitions]="false" [seriesColors]="COLOR_PALETTES">
                                <kendo-chart-value-axis>
                                    <kendo-chart-value-axis-item name="left"
                                        [labels]="selectedRequest?.yAxisConfig?.format ? { format: selectedRequest.yAxisConfig.format } : {}"></kendo-chart-value-axis-item>
                                    <kendo-chart-value-axis-item *ngIf="useRightAxis" name="valueAxis" [opposite]="true"
                                        [axisCrossingValue]="-20000000"
                                        [labels]="selectedRequest?.yAxisConfig?.format ? { format: selectedRequest.yAxisConfig.format } : {}">
                                    </kendo-chart-value-axis-item>
                                </kendo-chart-value-axis>

                                <kendo-chart-category-axis>
                                    <kendo-chart-category-axis-item *ngIf="!selectedRequest.isTimeCategory"
                                        [categories]="categories"
                                        [labels]="{ format: 'MMM d, HH:mm', rotation: -60, font: '10px Arial' }">
                                    </kendo-chart-category-axis-item>
                                    <kendo-chart-category-axis-item *ngIf=" selectedRequest.isTimeCategory"
                                        baseUnit="hours" color="var(--text-color)" [categories]="categories"
                                        [labels]="{ format: 'MMM d, HH:mm', rotation: -60, font: '10px Arial' }">
                                    </kendo-chart-category-axis-item>

                                </kendo-chart-category-axis>

                                <kendo-chart-series>
                                    <ng-container *ngFor="let s of series">
                                        <kendo-chart-series-item *ngIf="s.type === 'donut'; else nonDonut"
                                            [name]="s.name" [type]="s.type" [data]="s.data" [field]="'value'"
                                            [categoryField]="'category'" [padding]=0 [startAngle]="90" [holeSize]="100"
                                            colorField="color">
                                        </kendo-chart-series-item>

                                        <ng-template #nonDonut>
                                            <kendo-chart-series-item [gap]="1.5" [spacing]="0.2" [name]="s.name"
                                                [type]="s.type" [data]="s.data" [axis]="s.axis || undefined"
                                                [stack]="s.stack" colorField="color">

                                                <kendo-chart-series-item-tooltip>
                                                    <ng-template kendoChartSeriesTooltipTemplate let-dataItem="dataItem"
                                                        let-value="value" let-category="category">
                                                        <div>{{value |  number:'1.0-2' }}</div>
                                                        <div>{{s.name}}</div>
                                                    </ng-template>
                                                </kendo-chart-series-item-tooltip>

                                            </kendo-chart-series-item>
                                        </ng-template>
                                    </ng-container>
                                </kendo-chart-series>

                                <kendo-chart-tooltip [visible]="true">
                                    <ng-template kendoChartSeriesTooltipTemplate let-series="series"
                                        let-category="category" let-value="value" let-percentage="percentage">
                                        <div class="custom-tooltip">
                                            <ng-container *ngIf="series?.type === 'donut'; else nonDonutTpl">
                                                <strong>{{ category }}</strong>
                                                <div>{{ value | number:'1.0-2' }}</div>
                                                <div *ngIf="percentage !== undefined">
                                                    {{ (percentage * 100) | number:'1.0-1' }}%
                                                </div>
                                            </ng-container>

                                            <ng-template #nonDonutTpl>
                                                <div>{{ value | number:'1.0-2' }}</div>
                                            </ng-template>
                                        </div>
                                    </ng-template>
                                </kendo-chart-tooltip>
                                <kendo-chart-legend [visible]="!isDonutChart" position="bottom"
                                    orientation="horizontal"></kendo-chart-legend>
                            </kendo-chart>
                        </div>
                    </div>
                </ng-template>
            </disco-report>
        </ng-template>
    </disco-tab-provider>
</article>